import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f1c492c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6f1c492c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c492c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1c492c')) {
      api.createRecord('6f1c492c', component.options)
    } else {
      api.reload('6f1c492c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f1c492c&scoped=true", function () {
      api.rerender('6f1c492c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/theme/index.vue"
export default component.exports